import { render, staticRenderFns } from "./SportlerPlusLogo.vue?vue&type=template&id=2aa95ca2&"
import script from "./SportlerPlusLogo.vue?vue&type=script&lang=js&"
export * from "./SportlerPlusLogo.vue?vue&type=script&lang=js&"
import style0 from "./SportlerPlusLogo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports